import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ReactGA from 'react-ga4';

import { ThemeProvider } from "@mui/material/styles";
import { theme } from './Theme';
import CssBaseline from "@mui/material/CssBaseline";

import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";
import Home from "./components/home/Home";

import Portfolio from "./components/portfolio/Portfolio";
import GitHubStats from "./components/github/GitHubStats";
import VisualShowcase from "./components/showcase/VisualShowcase";
import Seo from "./components/Seo";

import "./App.css";
import "./assets/styles/Reset.css";

import NotFound from "./components/notfound/NotFound";

import { LanguageProvider } from "./context/LanguageContext";

// Função para rastrear cliques e eventos
const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label
  });
};

function App() {
  const [mode, setMode] = React.useState('dark'); // or 'light'

  // Function to toggle the theme mode
  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'dark' ? 'light' : 'dark'));
  };

  // Rastrear visualização de página
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  const main = process.env.REACT_APP_MAIN;

  const inicio = useRef();
  const portfolio = useRef();
  const blog = useRef();
  const servicos = useRef();
  const ebook = useRef();
  const newsletter = useRef();
  const depoimentos = useRef();

  const scrollToComponent = (refName) => {
    const refs = {
      inicio,
      portfolio,
      servicos,
      blog,
      ebook,
      newsletter,
      depoimentos,
    };

    const selectedRef = refs[refName];

    if (selectedRef && selectedRef.current) {
      var yOffset;
      if (refName === "InicioRef") {
        yOffset = -180;
      } else {
        yOffset = -120;
      }

      const yCoordinate =
        selectedRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;
      window.scrollTo(0, yCoordinate);
      
      // Rastrear evento de navegação
      trackEvent('Navigation', 'scroll', refName);
    }
  };

  const whatsappMsg = "Hi Jacques, I found your profile and would like to discuss an AI project.";
  const whatsappUrl = `https://wa.me/5584994514529?text=${encodeURIComponent(whatsappMsg)}`;

  return (
    <LanguageProvider>
      <ThemeProvider theme={theme(mode)}>
        <CssBaseline />
        <Router>
          <div className="App">
            <Seo />
            <Header scrollToComponent={scrollToComponent} />

            <Routes>
              <Route
                path={main}
                element={
                  <>
                    <div className="body-wrapper">
                      <div ref={inicio}>
                        <Home scrollToComponent={scrollToComponent} />
                      </div>
                      <VisualShowcase />
                       <div ref={portfolio}>
                        <Portfolio />
                      </div>
                      <GitHubStats />
                      {/*
                      <CTA />
                      <div ref={servicos}>
                        <Servicos />
                      </div>
                      <Blog />
                      <Ebook /> */}
                      {/* <FinalCTA /> */}
                    </div>
                  </>
                }
              ></Route>

              <Route path="*" element={<NotFound />} />
            </Routes>

            <div ref={newsletter}>
              <Footer scrollToComponent={scrollToComponent} />
            </div>

            {/* <div className="whats-btn">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                onClick={() => trackEvent('Contact', 'click', 'WhatsApp Float Button')}
              >
                <i className="uil uil-whatsapp whats"></i>
              </a>
            </div> */}
          </div>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
